import { Component, OnInit, Injector, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TableAbstractComponent } from 'src/app/common-page-components/classes/table-abstract-component';
import { HttpClient } from '@angular/common/http';
import { FilterAthletesService } from '../../../../athletes/services/filter-athletes.service';
import { FiltersAthleteGeneralService } from '../../../services/filters-athlete-general.service';
import { AthleteBiographyStore } from 'src/app/common-page-components/stores/entities-store/athlete-biography-store';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { of } from 'rxjs';

/**
 * An enum that represents the types of season statistics
 *
 * @export
 * @enum {number}
 */
export enum DataSeasonTypes {
  AvgArrow = 'avg',
  Matches = 'matches',
  Tiebbreaks = 'tier',
  RankingRound = 'round'
}
@Component({
  selector: 'app-athlete-season-statistics',
  templateUrl: './athlete-season-statistics.component.html',
  styleUrls: ['./athlete-season-statistics.component.scss']
})
export class AthleteSeasonStatisticsComponent extends TableAbstractComponent {
  /**
   * A season map to make the map more performant
   *
   * @memberof AthleteSeasonStatisticsComponent
   */
  seasonMap = {};

  /**
   * Property for  set the view of  desktop
   *
   * @memberof AthleteSeasonStatisticsComponent
   */
  viewDesktop = [250, 200];

  /**
   * Custom colors of chart
   *
   * @memberof AthleteSeasonStatisticsComponent
   */
  customColors = { domain: ["#0d5c9f", "#dee8f1"] }
  /**
   * An input property for define the default view selected
   *
   * @type {number}
   * @memberof AthleteSeasonStatisticsComponent
   */
  @Input()
  view: number = 1;

  /**
   * A method for set if mobile size is reached
   *
   * @type {boolean}
   * @memberof AthleteSeasonStatisticsComponent
   */
  isMobileProperty: boolean;

  /**
   * A property for set the default graph selected in mobile version
   *
   * @type {number}
   * @memberof AthleteSeasonStatisticsComponent
   */
  @Input()
  graphSelected: number = 1;

  season: any;
  constructor(
    injector: Injector,
    http: HttpClient,
    public common_service: FiltersAthleteGeneralService,
    break_point: BreakpointObserver
  ) {
    super(injector, common_service, common_service.athleteDetailStore);
    break_point.observe(['(max-width: 1030px)']).subscribe(next => {
      if (next.matches) {
        this.isMobileProperty = true;
      } else {
        this.isMobileProperty = false;
      }
    })
  }

  /**
   * The default hok. Uses for set map values
   *
   *
   * @memberof AthleteSeasonStatisticsComponent
   */
  ngOnInit() {
    this.common_service.athleteDetailStore.dataStream.asObservable().subscribe(next => {
      if (next && next[0].Stats.Season) {
        this.setView(1, next);
        this.season = this.getSeasonData();
        return;
      }
      if (next && next[0].Stats.LastSeason && next[0].Stats[next[0].Stats.LastSeason]) {
        this.setView(2, next);
        this.season = this.getSeasonData();

        return;
      }
      this.setView(3, next);
      this.season = this.getSeasonData();
    })

  }

  /**
   * A method for set the view to one specific
   *
   * @param {number} id Id of view (1 -> Current, 2 -> Last, 3-> Career)
   * @memberof AthleteSeasonStatisticsComponent
   */
  setView(id: number, season?:any) {
    this.seasonMap = {};
    this.view = id;
    Object.keys(DataSeasonTypes).map(key => DataSeasonTypes[key])
      .map(value => {
        this.seasonMap[value] = this.transformSeasonData(value,season);
      });
  }

  /**
   * An internal method for get the key of season view
   *
   * @private
   * @returns
   * @memberof AthleteSeasonStatisticsComponent
   */
  private seasonView(season?:any) {
    const data = season ? season: this.data;
    return this.view === 1 ? data[0].Stats.Season : this.view === 2 ? data[0].Stats.LastSeason : 'Career'
  }

  /**
   * An method for get the season data
   *
   * @returns
   * @memberof AthleteSeasonStatisticsComponent
   */
  getSeasonData(season?:any) {
    return season && season[0].Stats[this.seasonView(season)] ? season[0].Stats[this.seasonView(season)][0] :
    this.data[0] && this.data[0].Stats[this.seasonView(season)] ? this.data[0].Stats[this.seasonView(season)][0] : undefined
    ;
  }

  /**
   * A method for transform the data to the chart
   *
   * @param {DataSeasonTypes} type
   * @returns
   * @memberof AthleteSeasonStatisticsComponent
   */
  transformSeasonData(type: DataSeasonTypes, season:any) {
    const seasonData = this.getSeasonData(season);
    if (seasonData == undefined) {
      return;
    }
    this.season = seasonData;
    if (type === DataSeasonTypes.AvgArrow) {
      return [{
        name: 'AvgArrow',
        value: seasonData.AverageArr ? seasonData.AverageArr.toFixed(2) : 0,
      },
      {
        name: 'Remaining from total',
        value: seasonData.AverageArr ? 10 - seasonData.AverageArr.toFixed(2) : 10
      }
      ];
    }
    if (type === DataSeasonTypes.Matches) {
      return [{
        name: 'Match win percent',
        value: seasonData.MatchWinPercentage ? seasonData.MatchWinPercentage.toFixed(0) : 0,
      },
      {
        name: 'Remaining percent',
        value: seasonData.MatchWinPercentage ? 100 - seasonData.MatchWinPercentage.toFixed(0) : 100
      }
      ];
    }
    if (type === DataSeasonTypes.Tiebbreaks) {
      return [{
        name: 'Tiebreaks win percent',
        value: seasonData.TBWinPercentage ? seasonData.TBWinPercentage.toFixed(0) : 0,
      },
      {
        name: 'Remaining percent',
        value: seasonData.TBWinPercentage ? 100 - seasonData.TBWinPercentage.toFixed(0) : 100
      }
      ];
    }
    if (type === DataSeasonTypes.RankingRound) {
      return [{
        name: 'Ranking round',
        value: seasonData.QBest ? (seasonData.QBest / 720) * 100 : 0,
      },
      {
        name: 'Remaining percent',
        value: seasonData.QBest ? (720 - seasonData.QBest) / 720 * 100 : 100
      }
      ];
    }
  }

  /**
   * Check is the graph is selected for the mobile version
   *
   * @param {number} index number of index selected
   * @returns
   * @memberof AthleteSeasonStatisticsComponent
   */
  isSelectedGraph(index: number) {
    return (this.isMobileProperty === true) && (this.graphSelected === index);
  }

  /**
   * Perfom the action of selected one chart
   *
   * @param {number} index the index  of chart
   * @memberof AthleteSeasonStatisticsComponent
   */
  selectGraph(index: number) {
    this.graphSelected = index;
  }

  /**
   * A method for check if the athlete have information for pie charts.
   *
   * @memberof AthleteSeasonStatisticsComponent
   */
  hasSeasonData() {
    return this.data[0].Stats['Season'] || this.data[0].Stats['Career'] || this.data[0].Stats['LastSeason'];
  }

}
